export const FullPage404 = () => {
  return (
    <div style={{
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    }}>
      <h1 style={{fontSize:'60px'}}>404</h1>
      <p style={{fontSize:'25px'}}>Page Not Found</p>
    </div>
  );
};

export default FullPage404;